<template>
  <div>
    <modal
      size="small"
      v-if="visible"
      :show-controls="true"
      @close-modal="closeModal"
    >
      <div slot="header" class="col-md-12">
        Convidar Usuários
      </div>
      <div class="container" slot="content">
        <p>
          Você está convidando um usuário para a organização <b>{{ organizacao.nome }}</b>.
        </p>
        <p>
          <b>Atenção:</b> O usuário convidado receberá um e-mail com um link para criar uma conta e participar da organização.
          Usuários que já possuem conta no Escavador, se juntarão automaticamente à organização após aceitar o convite.
        </p>
        <div class="col-md-12">
          <div class="col-md-8">
            <input
              type="email"
              name="email"
              id="email"
              v-model="convidado.email"
              placeholder="Email"
            >
          </div>
          <div class="col-md-4">
            <select v-model="convidado.cargo">
              <option selected value=""> Selecione um Cargo</option>
              <option value="2">Desenvolvedor</option>
              <option value="3">Financeiro</option>
            </select>
          </div>
        </div>
        <div class="confirmation col-md-12">
          <button
            type="button"
            class="btn normal-background"
            @click="cancelar">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-md btn-success submit"
            @click="convidarUsuario"
          >
            <b>Convidar</b>
          </button>
        </div>
      </div>
      <div slot="footer">
      </div>
    </modal>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "../monitoramentos/Loading.vue";

export default {
  name: "AdicionarUsuarioOrganizacaoModal",
  props: {
    visible: Boolean,
    organizacao: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      convidado: {
          email: "",
          cargo: "",
          id: ""
      },
      submited:false,
    };
  },
  components: {
    Loading
  },
  methods: {
    convidarUsuario: function() {
      EventBus.$emit('loading-show');

      let resultadoValidacao = this.validarConvidado();

      if (resultadoValidacao !== "") {
        EventBus.$emit('loading-hide');
        this.$store.dispatch("showLoadingMessage", {
          message: resultadoValidacao,
          type: "error"
        });
        return;
      }

      this.submited = true;
      axios({
        method: "post",
        url: "organizacao/convites",
        data: {
          'cargo': this.convidado.cargo,
          'email': this.convidado.email,
        }
      })
        .then(response => {
          EventBus.$emit('loading-hide');
          this.$store.dispatch("showLoadingMessage", {
            message: "Convite enviado com sucesso!",
            type: "done"
          });

          this.convidado.id = response.data.id;
          // Envia os usuários convidados para o componente pai
          this.$emit("convidadoAdicionado", this.convidado);

          this.closeModal();
        })
        .catch((error) => {
          this.submited = false;

          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    closeModal: function() {
        this.$emit("closeModal");
    },
    cancelar: function() {
      this.convidado.nome = "";
      this.convidado.email = "";
      this.convidado.id = "";
      this.closeModal();
    },
    validarConvidado(){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      let erro = "";
      if (this.convidado.email === "") {
        erro = "Email não informado"
      }

      if(this.convidado.cargo === "") {
        erro = "Cargo não selecionado"
      }

      if (emailRegex.test(this.convidado.email) === false) {
        erro = "Email inválido"
      }

      if (erro === "") {
        return "";
      } else {
        return erro;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.mt
  margin-top 24px
.display-btn
 width 18%
.name-w
  width 80%
.token-field
  resize none
.name-field
  width 50%
.danger-background
  background-color #F44336
  border 1px solid #F44336
.danger-background:hover,
.danger-background:active,
.danger-background:focus
  background-color #B50E02
  border-color #B50E02
.title
  font-size 16px
  margin-bottom 3px
.success-background
  background-color #4CAF50
  border 1px solid #4CAF50
.normal-background
  color #000
  background-color #fff
  border 1px solid #d1d5db
.confirmation
  margin-top 40px
.submit
 float right
</style>
